import * as React from 'react';
import styles from '../styles/timelineStyles';
import { Switch, Route, RouteComponentProps } from 'react-router-dom';
import routes from '../../routes';
import { DoubleLeftOutlined, DoubleRightOutlined } from '@ant-design/icons';
import {
    AppComponentProps,
    AppRouteComponentMatchParams,
    ReleaseRouteComponentMatchParams,
} from '../../typescriptHelpers';
import Sider from 'antd/lib/layout/Sider';
import Button from 'antd/lib/button';
import SettingsNav from '../SettingsNav';
import Text from 'antd/lib/typography/Text';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers/reducers';
import { antGrey } from '../styles/globalStyles';
import { selectAppName } from '../../selectors/selectors';
import { AppMenu } from '../buildDistribution/mobileComponents/AppMenusSidebar';
import { ValidatedAndLoadedReleaseWrapper, ValidatedAppRouteWrapper } from '../ValidatedRouteComponents';
import { ReleaseStepsSidebar } from '@/components/sidebar/ReleaseStepsSidebar';
import TimelineHeader from '../TimelineHeader';

export const ReleasesSidebar = (props: AppComponentProps) => {
    const [isCollapsed, setIsCollapsed] = React.useState(false);
    const appName = useSelector((state: RootState) => selectAppName(state, props.appId));

    return (
        <Sider
            theme="light"
            width={280}
            collapsible={true}
            onCollapse={(collapsed) => setIsCollapsed(collapsed)}
            breakpoint="md"
            collapsedWidth={150}
            trigger={null}
            collapsed={isCollapsed}
        >
            <div
                style={{
                    ...styles.timelineStyle,
                }}
            >
                <div
                    style={{
                        ...styles.timelineHeaderStyle,
                        justifyContent: 'flex-end',
                    }}
                >
                    <Route
                        path={routes.app}
                        render={(routeProps: RouteComponentProps) => {
                            const appRouteProps = routeProps as RouteComponentProps<AppRouteComponentMatchParams>;

                            return (
                                <ValidatedAppRouteWrapper {...appRouteProps}>
                                    {(validatedAppComponentProps) => <TimelineHeader {...validatedAppComponentProps} />}
                                </ValidatedAppRouteWrapper>
                            );
                        }}
                    />
                    <Text
                        style={{
                            fontSize: 20,
                            flexGrow: 1,
                            textAlign: 'right',
                            fontWeight: 600,
                            color: antGrey.grey8,
                            paddingRight: 18,
                            paddingLeft: 20,
                            paddingTop: 12,
                            paddingBottom: 8,
                            width: '100%',
                        }}
                        ellipsis
                    >
                        {appName}
                    </Text>
                </div>
                <Switch>
                    <Route
                        path={routes.release}
                        render={(routeProps: RouteComponentProps) => {
                            const releaseRouteProps =
                                routeProps as RouteComponentProps<ReleaseRouteComponentMatchParams>;
                            return (
                                <ValidatedAndLoadedReleaseWrapper
                                    {...releaseRouteProps}
                                    showLoader={true}
                                    showNotFoundComponent
                                    showError
                                    withTracking
                                >
                                    {(validatedReleaseRouteProps) => {
                                        return <ReleaseStepsSidebar {...validatedReleaseRouteProps} />;
                                    }}
                                </ValidatedAndLoadedReleaseWrapper>
                            );
                        }}
                    />
                    <Route
                        path={routes.appSettings}
                        render={() => <SettingsNav appId={props.appId} orgId={props.orgId} isCollapsed={isCollapsed} />}
                    />
                    <Route
                        path={routes.app}
                        render={() => <AppMenu appId={props.appId} orgId={props.orgId} isCollapsed={isCollapsed} />}
                    />
                </Switch>
                <Route
                    path={routes.release}
                    children={({ match }) => {
                        const isReleasePath = !!match;

                        return (
                            <div
                                style={{
                                    padding: 8,
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    alignItems: 'flex-end',
                                    flexGrow: 1,
                                    flexShrink: 0,
                                    backgroundColor: isReleasePath ? '#EEEEEE' : 'transparent',
                                }}
                            >
                                <Button
                                    ghost
                                    style={{ borderColor: 'transparent', boxShadow: 'none' }}
                                    onClick={() => {
                                        const collapsed = isCollapsed;

                                        setIsCollapsed(!collapsed);
                                    }}
                                    icon={isCollapsed ? <DoubleRightOutlined /> : <DoubleLeftOutlined />}
                                ></Button>
                            </div>
                        );
                    }}
                />
            </div>
        </Sider>
    );
};
